package com.milta.feature.delivery.domain.entity

import com.milta.feature.route.domain.entity.GeocodeFailureReason
import com.milta.feature.route.domain.entity.GeocodeStatus

/**
 * HERE validation outcome of one DRAFT address (manual entry, before anything is persisted) —
 * never a replacement address, just a status and the coordinates when resolved. The coordinates
 * are sent back at creation so the server doesn't call HERE a second time.
 */
data class AddressValidation(
    val geocodeStatus: GeocodeStatus,
    val latitude: Double?,
    val longitude: Double?,
    /** Retour 26/10 (R1/R11) — why HERE refused [address] (Failed only), null otherwise. */
    val geocodeFailureReason: GeocodeFailureReason? = null,
    /** Retour 29/10 — the address HERE matched ("Trouvée : …"), null when not reported (older data). */
    val resolvedAddress: String? = null,
)
